import React from 'react';

import InfiniteScroll from 'react-infinite-scroll-component';
import { Display } from '@/components/Display/Display';
import errImg from '@/assets/images/res/error.webp';
import emptyImg from '@/assets/images/res/empty.webp';
import s from './index.module.scss';
import { DotLoading } from 'antd-mobile';

class PullRefreshList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            success: true,
            data: [],
            hasMore: true,
            page_num: 1,
            page_size: this.props.page_size || 10,
            manualRequest: this.props.manualRequest || false
        };
    }

    componentDidMount() {
        if (!this.state.manualRequest) {
            this.fetchMoreData();
        }
    }
    setData = (res, page_num, otherOptions) => {
        if (res?.data && res.data.length >= res.total) {
            this.setState({ hasMore: false });
        } else {
            this.setState({ hasMore: true });
        }
        this.setState({ data: res.data || [], page_num: page_num || this.state.page_num, ...otherOptions });
    };
    fetchMoreData = async () => {
        let { page_num, page_size } = this.state;

        this.setState({
            loading: page_num === 1
        });
        let res = await this.props.request({ page_num, page_size }).catch((err) => {
            console.log(err, 'err');
            this.setState({
                loading: false
            });
        });

        if (res && res.success) {
            let totalPage = Number(res.total) / page_size;

            if (page_num >= totalPage) {
                this.setState({ hasMore: false });
            } else {
                this.setState({ hasMore: true });
            }
            this.setState({ data: res.data || [], page_num: res.data?.length > 0 ? ++page_num : page_num, success: res.success }, () => {
                this.setState({ loading: false });
            });
        } else {
            this.setState({ success: false, data: [], loading: false });
        }
    };
    refresh = () => {
        this.setState(
            {
                page_num: 1
            },
            () => {
                this.fetchMoreData();
            }
        );
    };

    render() {
        return (
            <>
                <Display show={this.state.loading}>
                    <div className={s['status-div']}>
                        <span className={s['loading-wrap']}>
                            <DotLoading></DotLoading>
                        </span>
                    </div>
                </Display>
                <Display show={!this.state.loading}>
                    <Display show={this.state.success && this.state.data.length}>
                        <InfiniteScroll
                            scrollableTarget={this.props.scrollableTarget}
                            dataLength={this.state.data.length}
                            next={this.fetchMoreData}
                            hasMore={this.state.hasMore}
                            loader={<h3 className={s['extra-text']}>加载中...</h3>}
                            endMessage={<p className={s['extra-text']}>没有更多数据了</p>}
                            scrollThreshold={'30px'}
                            // 下拉刷新属性
                            refreshFunction={this.refresh}
                            pullDownToRefresh={this.props.pullDownToRefresh === undefined ? true : this.props.pullDownToRefresh}
                            pullDownToRefreshThreshold={50}
                            pullDownToRefreshContent={<h3 className={s['extra-text']}>&#8595; 下拉刷新</h3>}
                            releaseToRefreshContent={<h3 className={s['extra-text']}>&#8593; 松开刷新</h3>}
                        >
                            <div className={this.props.className}>
                                {this.state.data.map((item, index) => {
                                    return this.props.renderItem(item, index);
                                })}
                            </div>
                        </InfiniteScroll>
                    </Display>
                    <Display show={!this.state.success || this.state.data.length === 0}>
                        <div className={s['status-div']}>
                            <img src={this.state.success ? emptyImg : errImg} alt="" />
                            <div onClick={this.fetchMoreData}>
                                {this.state.success ? this.props.nodataContent || ' 抱歉，暂无数据哦 ~ ' : '加载失败, '}
                                {this.props.noRefresh ? null : <span className={s['retry']}>刷新页面</span>}
                            </div>
                        </div>
                    </Display>
                </Display>
            </>
        );
    }
}
export default PullRefreshList;
